import { Injectable, signal, WritableSignal, Type } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private _isOpen: WritableSignal<boolean> = signal(false);
  private _child: WritableSignal<Type<any> | null> = signal(null);
  private _params: WritableSignal<Record<string, any> | null> = signal(null);
  private _showCloseButton: WritableSignal<boolean> = signal(true);

  readonly isOpen = this._isOpen.asReadonly();
  readonly child = this._child.asReadonly();
  readonly params = this._params.asReadonly();
  readonly showCloseButton = this._showCloseButton.asReadonly();
  private modalCloseSubject = new Subject<any>();

  open<T>(component: Type<T>, params?: Partial<T>, showCloseButton: boolean = true): Observable<any> {
    this._child.set(component);
    this._params.set(params ?? null);
    this._isOpen.set(true);
    this._showCloseButton.set(showCloseButton);
    document.body.style.overflow = 'hidden'; // Lock body scroll
    return this.modalCloseSubject.asObservable();
  }
  close(data?: any) {
    this._isOpen.set(false);
    this._child.set(null);
    this._params.set(null);
    this._showCloseButton.set(true);
    document.body.style.overflow = ''; // Restore body scroll
    this.modalCloseSubject.next(data);
    this.modalCloseSubject.complete();
    this.modalCloseSubject = new Subject<any>();
  }
}

